var _style, _path, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCinedMark3Color(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 306.06 500",
    style: {
      enableBackground: "new 0 0 306.06 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;}\n\t.st1{fill:#009999;}\n\t.st2{fill:#FFFFFF;}\n\t.st3{fill:#CC9933;}\n\t.st4{fill:#391D69;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M162,500"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M306.06,166.67v-13.64c0,4.57-0.21,9.09-0.61,13.56L306.06,166.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M306.06,153.03c0,4.57-0.21,9.09-0.61,13.56h-0.01l-66.47-8.69c0.09-1.61,0.14-3.24,0.14-4.87 c0-47.22-38.86-86.08-86.08-86.08c-41.27,0-76.16,29.69-84.29,68.7h-0.01l-66.47-8.69C14.78,55.24,77.95,0,153.03,0 C236.98,0,306.06,69.08,306.06,153.03z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M0,126.67v26.36c0-8.88,0.78-17.59,2.26-26.07L0,126.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M239.11,153.03c0,1.63-0.05,3.26-0.14,4.87h-0.01c-2.56,44.99-40.35,81.21-85.94,81.21 c-47.22,0-86.08-38.86-86.08-86.08c0-5.95,0.62-11.76,1.79-17.38h0.01c8.13-39.01,43.02-68.7,84.29-68.7 C200.25,66.95,239.11,105.81,239.11,153.03z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M305.44,166.59c-1.58,17.71-6.22,34.59-13.41,50.1l-47.95,108.54v0.01L50.82,299.98l-36.79-83.29 c-9-19.43-14.03-41-14.03-63.66c0-3.33,0.11-6.64,0.32-9.92c0.15-2.18,0.34-4.36,0.57-6.52c0.12-1.08,0.25-2.15,0.39-3.23 c0.28-2.15,0.6-4.28,0.97-6.4h0.01l66.47,8.69c-1.17,5.62-1.79,11.43-1.79,17.38c0,47.22,38.86,86.08,86.08,86.08 c45.59,0,83.38-36.22,85.94-81.21h0.01L305.44,166.59z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M244.08,325.23L174.47,482.8l-2,4.53c-7.46,16.89-31.42,16.89-38.88,0l-4.63-10.48L50.82,299.98L244.08,325.23z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCinedMark3Color);
export default __webpack_public_path__ + "static/media/CINED_Mark_3color.2eb0eeb4f85e55c6d68fb9ea45a6bf0d.svg";
export { ForwardRef as ReactComponent };